<template>
  <VaModal
    v-model="showWarning"
    size="small"
    :close-button="false"
    :stateful="false"
    :hide-default-actions="true"
    no-outside-dismiss
    no-escape-dismiss
  >
    <div class="text-center py-4">
      <VaIcon name="warning" size="48px" color="warning" class="mb-4" />
      <p class="text-lg mb-4">
        Your session will expire in <strong>{{ timeRemainingFormatted }}</strong>
      </p>
      <p class="text-sm text-gray-600 mb-6">
        You will be automatically logged out due to inactivity. Click "Stay Logged In" to continue your session.
      </p>
    </div>

    <template #footer>
      <div class="flex w-full justify-center gap-2">
        <VaButton color="primary" @click="extendSession"> Stay Logged In </VaButton>
        <VaButton preset="secondary" color="danger" @click="logout"> Logout Now </VaButton>
      </div>
    </template>
  </VaModal>
</template>

<script setup lang="ts">
import { useSessionWarning } from '../../composables/useSessionWarning'

const { showWarning, timeRemainingFormatted, extendSession, logout } = useSessionWarning()
</script>

<style scoped>
.va-modal__inner {
  max-width: 400px;
}
</style>
